import { useFetchEnterpriseEmployeesCount } from 'hooks/useFetchEnterpriseEmployeesCount';

export const usePatientsSummary = (): {
  stats: { total: number; withSession: number; withoutSession: number };
  isLoading: boolean;
} => {
  const totalQuery = useFetchEnterpriseEmployeesCount();
  const withSessionQuery = useFetchEnterpriseEmployeesCount({ hasUpcomingSession: true });
  const total = totalQuery.data ?? 0;
  const withSession = withSessionQuery.data ?? 0;

  return {
    stats: {
      total,
      withSession,
      withoutSession: Math.max(total - withSession, 0),
    },
    isLoading: totalQuery.isLoading || withSessionQuery.isLoading,
  };
};
